<script lang="ts">
    import type { InputTypes, SettingFormInputDefinition } from 'header/types';
    import * as fields from './fields';

    interface Props {
        field: SettingFormInputDefinition;
        nolabel: boolean;
    }

    let { field, nolabel }: Props = $props();

    const getFieldComponentName = (fieldType: InputTypes) => {
        switch (fieldType) {
            case 'Select':
            case 'SelectNumber':
                return 'Select';
            case 'SelectClearable':
            case 'SelectNumberClearable':
                return 'SelectClearable';
            case 'MultiSelect':
                return 'MultiSelect';
            case 'RichMultiSelect':
                return 'RichMultiSelect';
            case 'CheckBox':
                return 'CheckBox';
            case 'NumberInput':
                return 'NumberInput';
            case 'TextInput':
                return 'TextInput';
            case 'NullableTextInput':
                return 'NullableTextInput';
            case 'HierarchyCustomizationInput':
                return 'HierarchyCustomizationInput';
            case 'TextInputWithButton':
                return 'TextInputWithButton';
            case 'Information':
                return 'Information';
            case 'TopN':
                return 'TopN';
            case 'Condition':
                return 'ConditionForm';
            case 'Drill':
                return 'DrillForm';
            case 'AutoDate':
                return 'AutoDate';
            case 'InputBWQuery':
                return 'InputBWQuery';
            case 'Shortcuts':
                return 'Shortcuts';
            case 'SelectCurrentView':
                return 'SelectCurrentView';
            case 'DatabricksCondition':
                return 'DatabricksCondition';
            default:
                return 'InputPlaceholder';
        }
    };
</script>

<!-- svelte-ignore a11y_label_has_associated_control -->
<!-- didn't find any correct migration way for this case, otherwise, it is working -->
<div class="field">
    {#if !nolabel}
        <div class="field__label">{field.label}:</div>
    {/if}
    <div class="field__control">
        <svelte:component this={fields[getFieldComponentName(field.type)]} {field} on:change />
    </div>
</div>

<style lang="scss" scoped>
    .field {
        display: flex;
        overflow: hidden;

        &__label {
            flex: 0 0 33.3333%;
            overflow: hidden;
            word-break: break-word;
            padding: 0.1rem 0.5rem 0 0;
            font-size: 0.8rem;
        }
        &__control {
            flex: 1 0 66.6666%;
            overflow: hidden;
        }
    }
</style>
